import { useState, useEffect } from "react";
import CrmLayout from "@/components/feature/CrmLayout";
import { fetchApi } from "@/services/apiService";

export default function CompanyProfilePage() {
  const [companyName, setCompanyName] = useState("PropMax Solutions");
  const [industryName, setIndustryName] = useState("Real Estate");
  const [pipelineTemplate, setPipelineTemplate] = useState("Real Estate (7 stages)");
  const [activeUsersCount, setActiveUsersCount] = useState("4");
  const [planName, setPlanName] = useState("Professional");

  useEffect(() => {
    // 1. Fetch company details
    fetchApi<any>("/company", undefined, null)
      .then((res) => {
        const item = Array.isArray(res?.data) ? res.data[0] : res?.data || res;
        if (item?.name) setCompanyName(item.name);
      })
      .catch(() => {});

    // 2. Fetch active industry & pipeline template
    fetchApi<any>("/industry-templates/get-all", undefined, null)
      .then((res) => {
        const activeKey = res?.active?.key || "real-estate";
        const templates = res?.data || [];
        const matched = templates.find((t: any) => String(t.id) === String(activeKey) || t.name?.toLowerCase().includes(activeKey));
        if (matched) {
          setIndustryName(matched.name);
          setPipelineTemplate(`${matched.name} (${matched.stages || matched.stageList?.length || 7} stages)`);
        } else if (activeKey) {
          const cap = activeKey.split("-").map((w: string) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
          setIndustryName(cap);
          setPipelineTemplate(`${cap} Pipeline`);
        }
      })
      .catch(() => {});

    // 3. Fetch active users count
    fetchApi<any>("/auth/company-user/all", undefined, null)
      .then((res) => {
        const userList = Array.isArray(res)
          ? res
          : Array.isArray(res?.items)
          ? res.items
          : Array.isArray(res?.data)
          ? res.data
          : [];
        if (userList.length > 0) {
          setActiveUsersCount(String(userList.length));
        }
      })
      .catch(() => {});
  }, []);

  const companyDetails = [
    { label: "Company Name", value: companyName, icon: "ri-building-line" },
    { label: "Industry", value: industryName, icon: "ri-briefcase-line" },
    { label: "Pipeline Template", value: pipelineTemplate, icon: "ri-flow-chart" },
    { label: "Active Users", value: activeUsersCount, icon: "ri-team-line" },
    { label: "Plan", value: planName, icon: "ri-vip-crown-line" },
  ];

  return (
    <CrmLayout title="Company Profile">
      <div className="p-5 md:p-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Company Profile</h1>
          <p className="text-sm text-gray-500 mt-0.5">View your company configuration and plan details</p>
        </div>

        <div className="mt-6 max-w-2xl">
          <div className="bg-white rounded-xl border border-gray-200 p-6">
            <div className="space-y-5">
              {companyDetails.map((detail) => (
                <div key={detail.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center flex-shrink-0">
                    <i className={`${detail.icon} text-gray-400 text-lg`} />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs uppercase text-gray-500 tracking-wider font-semibold">{detail.label}</p>
                    <p className="text-sm text-gray-900 font-medium mt-0.5">{detail.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-5 border-t border-gray-100">
              <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-amber-50 border border-amber-100">
                <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-amber-600 text-sm" />
                </div>
                <p className="text-xs text-amber-700">
                  Company profile settings are managed by your administrator. Contact support to update company details or change your plan.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CrmLayout>
  );
}